import * as React from "react"
import { Redirect } from "react-router-dom"
import {
    RealTimeRoutes
} from "./pages"

const redirectRoute = [{
    path: "/",
    exact: true,
    needLogin: false,
    component: () => {
        const homePage = '/real-time'
        return <Redirect to={homePage} />
    }
}]

const routes = [
    ...RealTimeRoutes,
    ...redirectRoute
]

export default routes
